module.exports = "\n<div>\n\n  <div class=\"font-weight-bold\">{{newLabel}}</div>\n  <div>{{newValue}}</div>\n\n  <div class=\"my-2\"></div>\n\n  <div class=\"font-weight-bold\">{{oldLabel}}</div>\n  <div>{{oldValue}}</div>\n\n\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/block/block-maintenance-detail/components/template.html
// module id = NgFF
// module chunks = 0